<template>
    <section class="cta-section">
        <div class="container">
            <div class="cta-content">
                <!-- 微鲤AI Logo -->
                <div class="cta-logo">
                    <div class="logo-icon logo-image">
                        <img :src="logoUrl" alt="微鲤AI" class="logo-image" />
                    </div>
                </div>

                <!-- Main Content -->
                <div class="cta-header">
                    <h2 class="cta-title">{{ title }}</h2>
                    <p class="cta-description">{{ description }}</p>
                </div>

                <!-- CTA Button -->
                <div class="cta-actions">
                    <button @click="handleButtonClick" class="cta-primary-btn">
                        {{ buttonText }}
                    </button>

                    <p class="cta-disclaimer">{{ footerText }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useUserStore } from '~/stores/user'
import { showLoginModal } from '~/utils/emitter'

const props = defineProps({
    // 主标题
    title: {
        type: String,
        default: '谁备开始创作了吗？'
    },
    // 描述文案
    description: {
        type: String,
        default: '立即体验 Wan 2.5，将您的创意转化为精彩图像'
    },
    // 按钮文字
    buttonText: {
        type: String,
        default: '立即体验 Wan AI'
    },
    // 底部提示文字
    footerText: {
        type: String,
        default: '无需信用卡'
    }
})

const userStore = useUserStore()

// 固定的 logo 图片地址
const logoUrl = 'https://static.weryai.com/growth/image/4608e0a35205ff929dba2ea3c51f6e62.webp'

// 处理按钮点击
const handleButtonClick = () => {
    // 检查登录状态
    if (!userStore.isLoggedIn) {
        showLoginModal()
        return
    }

    // 已登录，平滑滚动到顶部
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
}
</script>
<style scoped lang="less">
@import '~/assets/css/howToUse.css';
</style>